import { render, staticRenderFns } from "./CategoryPerformanceTable.vue?vue&type=template&id=68ce7d91&scoped=true"
import script from "./CategoryPerformanceTable.vue?vue&type=script&lang=js"
export * from "./CategoryPerformanceTable.vue?vue&type=script&lang=js"
import style0 from "./CategoryPerformanceTable.vue?vue&type=style&index=0&id=68ce7d91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ce7d91",
  null
  
)

export default component.exports